import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);

  return (
    <>
      <style>{`
        .form-control::placeholder {
          color: white !important;
          opacity: 0.7;
        }
        .form-control:-ms-input-placeholder {
          color: white !important;
          opacity: 0.7;
        }
        .form-control::-ms-input-placeholder {
          color: white !important;
          opacity: 0.7;
        }
        /* Dropdown Menu Styles */
        .menu-item.has-children {
          position: relative;
        }
        .menu-item.has-children:hover .sub-menu {
          display: block;
        }
        .sub-menu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          background: #fff;
          min-width: 200px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
          z-index: 1000;
          border-radius: 4px;
          padding: 8px 0;
          max-height: calc(100vh - 120px);
          overflow-y: auto;
        }
        .sub-menu, .sub-menu .menu-item {
          list-style: none !important;
          padding-left: 0 !important;
          margin-left: 0 !important;
        }
        .sub-menu .menu-item {
          padding: 0;
          list-style: none !important;
          margin-left: 0 !important;
        }
        .sub-menu .menu-link {
          padding: 8px 20px;
          color: #333;
          display: block;
          transition: all 0.3s ease;
        }
        .sub-menu .menu-link:hover {
          background: #0A3C3F;
          color: #fff;
        }
        .sub-menu .menu-link div {
          font-size: 14px;
        }

        /* Mobile Menu Styles */
        @media (max-width: 991px) {
          .primary-menu {
            position: fixed;
            top: 0;
            right: -300px;
            width: 280px;
            height: 100vh;
            background: #fff;
            padding: 0;
            transition: all 0.3s ease;
            z-index: 9999;
            overflow-y: auto;
            box-shadow: -2px 0 15px rgba(0,0,0,0.1);
          }

          .primary-menu.active {
            right: 0;
          }

          .primary-menu .menu-container {
            display: flex;
            flex-direction: column;
            padding: 0;
            margin: 0;
            min-height: 100vh;
            background: #fff;
          }

          .primary-menu .menu-item:first-child {
            border-top: 1px solid rgba(0,0,0,0.05);
          }

          .primary-menu .menu-item:last-child {
            border-bottom: none;
          }

          .primary-menu .menu-item {
            width: 100%;
            border-bottom: 1px solid rgba(0,0,0,0.05);
            margin: 0;
            padding: 0;
            background: #fff;
          }

          .primary-menu .menu-link {
            padding: 15px 25px;
            color: #333;
            display: block;
            width: 100%;
            font-size: 15px;
            font-weight: 500;
            transition: all 0.3s ease;
            background: #fff;
          }

          .primary-menu .menu-link:hover {
            background: #0A3C3F;
            color: #fff;
          }

          .primary-menu .menu-link div {
            font-size: 15px;
            font-weight: 500;
          }

          .primary-menu .sub-menu {
            position: static;
            width: 100%;
            box-shadow: none;
            padding: 0;
            display: none;
            background: #f8f9fa;
            border-radius: 0;
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease-out;
          }

          .primary-menu .menu-item.has-children.active .sub-menu {
            display: block;
            max-height: 2000px;
            transition: max-height 0.5s ease-in;
          }

          .primary-menu .menu-item.has-children .menu-link {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 30px;
            position: relative;
          }

          .primary-menu .menu-item.has-children .menu-link i {
            transition: transform 0.3s ease;
            font-size: 12px;
            color: #666;
            position: absolute;
            right: 25px;
            top: 50%;
            transform: translateY(-50%);
          }

          .primary-menu .menu-item.has-children.active .menu-link i {
            transform: translateY(-50%) rotate(180deg);
          }

          .primary-menu .sub-menu .menu-link {
            padding: 12px 25px 12px 35px;
            font-size: 14px;
            color: #555;
            font-weight: 400;
            background: #f8f9fa;
            border-bottom: 1px solid rgba(0,0,0,0.05);
          }

          .primary-menu .sub-menu .menu-link:last-child {
            border-bottom: none;
          }

          .primary-menu .sub-menu .menu-link:hover {
            background: #0A3C3F;
            color: #fff;
          }

          .cnvs-hamburger {
            display: block;
            z-index: 10000;
            position: relative;
          }

          .menu-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 9998;
            display: none;
            opacity: 0;
            transition: opacity 0.3s ease;
            backdrop-filter: blur(2px);
          }

          .menu-overlay.active {
            display: block;
            opacity: 1;
          }

          /* Hamburger Button Styles */
          .cnvs-hamburger {
            width: 30px;
            height: 30px;
            position: relative;
            cursor: pointer;
            background: transparent;
            border: none;
            padding: 0;
          }

          .cnvs-hamburger-box {
            width: 30px;
            height: 24px;
            display: inline-block;
            position: relative;
          }

          .cnvs-hamburger-inner {
            display: block;
            top: 50%;
            margin-top: -2px;
          }

          .cnvs-hamburger-inner,
          .cnvs-hamburger-inner::before,
          .cnvs-hamburger-inner::after {
            width: 30px;
            height: 2px;
            background-color: #333;
            border-radius: 4px;
            position: absolute;
            transition: transform 0.15s ease;
          }

          .cnvs-hamburger-inner::before,
          .cnvs-hamburger-inner::after {
            content: "";
            display: block;
          }

          .cnvs-hamburger-inner::before {
            top: -10px;
          }

          .cnvs-hamburger-inner::after {
            bottom: -10px;
          }

          .cnvs-hamburger.is-active .cnvs-hamburger-inner {
            transform: rotate(45deg);
          }

          .cnvs-hamburger.is-active .cnvs-hamburger-inner::before {
            transform: rotate(90deg);
            top: 0;
          }

          .cnvs-hamburger.is-active .cnvs-hamburger-inner::after {
            transform: rotate(90deg);
            bottom: 0;
          }

          /* Scrollbar Styles */
          .primary-menu::-webkit-scrollbar {
            width: 6px;
          }

          .primary-menu::-webkit-scrollbar-track {
            background: #f1f1f1;
          }

          .primary-menu::-webkit-scrollbar-thumb {
            background: #0A3C3F;
            border-radius: 3px;
          }

          .primary-menu::-webkit-scrollbar-thumb:hover {
            background: #072a2c;
          }
        }

        /* WhatsApp Button Styles */
        .whatsapp-float {
          position: fixed;
          bottom: 30px;
          right: 30px;
          background-color: #25d366;
          color: #FFF;
          border-radius: 50px;
          text-align: center;
          font-size: 30px;
          box-shadow: 2px 2px 3px rgba(0,0,0,0.2);
          z-index: 100;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .whatsapp-float:hover {
          background-color: #128C7E;
          color: #FFF;
          transform: scale(1.1);
        }

        .whatsapp-float i {
          font-size: 35px;
        }

        @media (max-width: 767px) {
          .whatsapp-float {
            width: 50px;
            height: 50px;
            bottom: 20px;
            right: 20px;
          }
          .whatsapp-float i {
            font-size: 30px;
          }
        }

        /* Download Brochure Button Styles */
        .brochure-float {
          position: fixed;
          bottom: 100px;
          right: 30px;
          background-color: #0A3C3F;
          color: #FFF;
          border-radius: 50px;
          text-align: center;
          font-size: 30px;
          box-shadow: 2px 2px 3px rgba(0,0,0,0.2);
          z-index: 100;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .brochure-float:hover {
          background-color: #072a2c;
          color: #FFF;
          transform: scale(1.1);
        }

        .brochure-float i {
          font-size: 35px;
        }

        @media (max-width: 767px) {
          .brochure-float {
            width: 50px;
            height: 50px;
            bottom: 80px;
            right: 20px;
          }
          .brochure-float i {
            font-size: 30px;
          }
        }
      `}</style>
      <header id="header" className="header-size-md dark transparent-header floating-header" data-sticky-shrink="false" data-responsive-class="not-dark">
        <div id="header-wrap" className="border-0">
          <div className="container rounded">
            <div className="header-row justify-content-lg-between">
              {/* Logo */}
              <div id="logo" className="me-lg-0 col-lg-3">
                <a href="/">
                  <img className="logo-default ms-0" srcSet="demos/business/images/logo.png, demos/business/images/logo-dark@2x.png 2x" src="demos/business/images/logo@2x.png" alt="Rexroth Logo" />
                  <img className="logo-dark ms-0" srcSet="demos/business/images/logo-dark.png, demos/business/images/logo-dark@2x.png 2x" src="demos/business/images/logo-dark@2x.png" alt="Rexroth Logo" />
                </a>
              </div>
              <div className="header-misc col-lg-3 justify-content-lg-end ms-0">
                <a href="tel:+919824239449" className="button rounded button-border border-contrast-900 text-contrast-900 h-border-transparent h-text-contrast-100 h-bg-contrast-900"><i className="fa-solid fa-phone-volume d-block d-xl-none m-0"></i><span className="d-none d-xl-block">Contact Us</span></a>
              </div>
              <div className="primary-menu-trigger">
                <button 
                  className={`cnvs-hamburger ${isMenuOpen ? 'is-active' : ''}`} 
                  type="button" 
                  title="Open Mobile Menu"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  <span className="cnvs-hamburger-box"><span className="cnvs-hamburger-inner"></span></span>
                </button>
              </div>
              <div className={`menu-overlay ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)}></div>
              <nav className={`primary-menu ${isMenuOpen ? 'active' : ''}`}>
                <ul className="menu-container">
                  <li className="menu-item"><a className="menu-link" href="/" onClick={() => setIsMenuOpen(false)}><div>Home</div></a></li>
                  <li className="menu-item"><a className="menu-link" href="/global-presence" onClick={() => setIsMenuOpen(false)}><div>Global Presence</div></a></li>
                  <li className={`menu-item has-children ${isCategoriesOpen ? 'active' : ''}`}>
                    <a 
                      className="menu-link" 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault();
                        setIsCategoriesOpen(!isCategoriesOpen);
                      }}
                    >
                      <div>Categories <i className="bi-chevron-down ms-1"></i></div>
                    </a>
                    <ul className="sub-menu">
                      <li className="menu-item"><a className="menu-link" href="/products" onClick={() => setIsMenuOpen(false)}><div>Explore By Faculties</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/dietary-supplements" onClick={() => setIsMenuOpen(false)}><div>Dietary Supplements</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/syrups-and-suspensions" onClick={() => setIsMenuOpen(false)}><div>Syrups & Suspensions</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/gummies" onClick={() => setIsMenuOpen(false)}><div>Gummies</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/effervescent-tablets" onClick={() => setIsMenuOpen(false)}><div>Effervescent Tablets</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/fitness-supplements-tablets" onClick={() => setIsMenuOpen(false)}><div>Fitness Supplements Tablets</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/fitness-supplements-powders" onClick={() => setIsMenuOpen(false)}><div>Fitness Supplements Powders</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/healthcare-protein-supplements" onClick={() => setIsMenuOpen(false)}><div>Healthcare Protein Supplements</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/energy-drink-and-sachets" onClick={() => setIsMenuOpen(false)}><div>Energy Drink & Sachets</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/softgel-supplements" onClick={() => setIsMenuOpen(false)}><div>Softgel Supplements</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/skin-and-hair-supplements" onClick={() => setIsMenuOpen(false)}><div>Skin & Hair Care</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/cosmetics" onClick={() => setIsMenuOpen(false)}><div>Cosmetic</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/herbals" onClick={() => setIsMenuOpen(false)}><div>Herbal</div></a></li>
                      <li className="menu-item"><a className="menu-link" href="/other-nutraceutical-products" onClick={() => setIsMenuOpen(false)}><div>Other Nutraceutical Products</div></a></li>
                    </ul>
                  </li>
                  <li className="menu-item"><a className="menu-link" href="/blogs" onClick={() => setIsMenuOpen(false)}><div>Blogs</div></a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>
      <a 
        href="/brochure.pdf" 
        className="brochure-float" 
        download
        title="Download Company Brochure"
      >
        <i className="fas fa-file-pdf"></i>
      </a>
      <a 
        href="https://wa.me/919824239449" 
        className="whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
        title="Contact us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </>
  );
};

export default Header;